/** Compact tick labels for Chart.js axes (1k, 2.5k, 10k, …) */
export function formatAxisCompactK(value: string | number): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return String(value);
  const abs = Math.abs(n);
  if (abs < 1000) return String(Math.round(n));
  const k = n / 1000;
  const rounded = Math.abs(k - Math.round(k)) < 1e-6 ? Math.round(k) : Math.round(k * 10) / 10;
  return `${rounded}k`;
}

/** Data label formatter for bar/line numeric values */
export function formatDataLabelCompact(value: number): string {
  if (!Number.isFinite(value)) return '';
  if (Math.abs(value) < 1000) return String(value);
  return formatAxisCompactK(value);
}
